export function initiateSlider(direction) {
    const slider = document.querySelector('.product-detail__slider');
    const list = slider.querySelector('ul');
    const items = list.querySelectorAll('li');

    const hiddenItems = [];

    items.forEach(function (item) {
        if (item.classList.contains('hidden')) {
            hiddenItems.push(item);
        }
    });

    let score = hiddenItems.length;
    let endItem;

    if (list.parentElement.offsetWidth > 400) {
        try {
            endItem = items[score].nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling;
        } catch {
            endItem = null;
        }   
    } else {
        try {
            endItem = items[score].nextElementSibling.nextElementSibling.nextElementSibling;
        } catch {
            endItem = null;
        }
    }

    if (direction === 'right') {
        if (endItem === null || endItem === undefined) {
            return;
        } else {
            items[score].classList.add('hidden');
            return score++;
        }
    }

    if (direction === 'left') {
        if (score <= 0) {
            return;
        } else {
            items[score - 1].classList.remove('hidden');
            return score--;
        }
    }
}

